import BaseApiAction from "@Actions/base-api-action";

export default class UploadUserImage extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: "users-uploadUserImage",
      payload: {
        fileName: this._payload.fileName,
        url: this._payload.url,
      },
    });
  }
}
